<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding">
  <ion-card
    class="border-r10 ion-no-margin ion-margin-bottom card-white-background-color d-flex ion-align-items-center ion-justify-content-between ion-padding"
    [class.offer-inactive]="!isOfferApplicable(item)"
    *ngFor="let item of offerList"
  >
    <div class="offer-content">
      <ion-text
        class="fs-3 font600 ion-no-padding card-primary-text-color offer-title"
      >
        {{ getOfferTitle(item) }}
      </ion-text>
      <ion-text
        class="fs-2 font500 ion-no-padding card-secondary-text-color offer-subtitle"
        *ngIf="item?.activationText"
      >
        {{ item?.activationText }}
      </ion-text>
    </div>
    <ion-button
      class="primary-btn apply-btn fs-2 font600"
      [disabled]="!isOfferApplicable(item)"
      (click)="ApplyOffer(item)"
    >
      {{ "modals.offer_list_modal.apply" | translate }}
    </ion-button>
  </ion-card>
</ion-content>
